
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionLanguageType,
    CollectionLanguagePayloadType,
} from "@/common/types/collection-language";

export async function collectionLanguageList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/language/list${queryString}`
    );
}

export async function collectionLanguageGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/language/${item_id}/show`
    );
}

export async function collectionLanguageCreate(
    collection_id: string,
    payload: CollectionLanguagePayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/language/create`,
        payload
    );
}

export async function collectionLanguagePatch(
    item_id: string,
    payload: Partial<CollectionLanguageType>
) {
    return await clientAxios.patch(
        `collection/language/${item_id}/patch`,
        { payload }
    );
}

export async function collectionLanguageDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/language/${item_id}/delete`,
    );
}
